function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import noop from 'lodash/noop';
import isEqual from 'lodash/isEqual';
import { ChevronDownIconSmall, MoreCircleIcon } from '@domain-group/fe-co-icon';
import Loader from '@domain-group/fe-co-loader';
import SelectRoot from './select-root';
import * as styles from './select.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Size = Object.freeze({
  Small: 'small',
  Regular: 'regular'
});

var Select = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Select, _React$PureComponent);

  var _super = _createSuper(Select);

  function Select(_props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "getSelectedItem", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (props.value === null) {
        return null;
      }

      var value = props.value || props.defaultValue;
      var options = props.options || [];
      return options.find(function (option) {
        return option.value === value;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "shouldUpdateSelected", function () {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (prevProps.value !== _this.props.value) {
        return true;
      }

      var selected = _this.getSelectedItem(_this.props);

      var prevSelected = _this.getSelectedItem(prevProps);

      return !isEqual(selected, prevSelected);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (selectedItem) {
      if (_this.props.onChange) {
        _this.props.onChange(selectedItem);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "stateChangeHandler", function (_ref) {
      var isOpen = _ref.isOpen,
          selectedItem = _ref.selectedItem;
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          onOpen = _this$props.onOpen,
          value = _this$props.value;

      if (isOpen === false && onClose) {
        onClose();
      }

      if (isOpen === true && onOpen) {
        onOpen();
      }

      var componentIsNotControllerByProps = !value && selectedItem;

      if (componentIsNotControllerByProps) {
        _this.setState({
          selectedItem: selectedItem
        });
      }
    });

    var _selectedItem = null; // set the components inital state with the value or defaultValue if given

    var _value = _props.value || _props.defaultValue;

    if (typeof _value !== 'undefined') {
      _selectedItem = _this.getSelectedItem(_props);
    }

    _this.state = {
      selectedItem: _selectedItem || null
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.shouldUpdateSelected(prevProps)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedItem: this.getSelectedItem(this.props)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          instanceId = _this$props2.instanceId,
          size = _this$props2.size,
          disabled = _this$props2.disabled,
          loading = _this$props2.loading,
          label = _this$props2.label,
          autoFocus = _this$props2.autoFocus,
          isInvalid = _this$props2.isInvalid,
          optionComponent = _this$props2.optionComponent,
          onFocus = _this$props2.onFocus,
          className = _this$props2.className,
          labelHidden = _this$props2.labelHidden,
          floatingLabel = _this$props2.floatingLabel,
          appearance = _this$props2.appearance,
          nowrap = _this$props2.nowrap,
          alignBody = _this$props2.alignBody,
          dropdownMaxHeight = _this$props2.dropdownMaxHeight,
          stretched = _this$props2.stretched,
          required = _this$props2.required,
          hideSelectedOption = _this$props2.hideSelectedOption;
      var placeholder = loading ? 'Loading...' : this.props.placeholder;
      var options = loading ? [] : this.props.options;
      var isSmall = size === Size.Small;
      return ___EmotionJSX(Downshift, {
        id: instanceId,
        itemToString: function itemToString(item) {
          return item ? item.value : '';
        },
        onChange: this.handleChange,
        selectedItem: this.state.selectedItem,
        onStateChange: this.stateChangeHandler
      }, function (_ref2) {
        var id = _ref2.id,
            highlightedIndex = _ref2.highlightedIndex,
            isOpen = _ref2.isOpen,
            getItemProps = _ref2.getItemProps,
            getLabelProps = _ref2.getLabelProps,
            getToggleButtonProps = _ref2.getToggleButtonProps,
            getMenuProps = _ref2.getMenuProps,
            selectedItem = _ref2.selectedItem,
            getInputProps = _ref2.getInputProps,
            getRootProps = _ref2.getRootProps;
        var hasLabel = selectedItem && selectedItem.label;
        var visibleLabel = selectedItem && selectedItem.label || placeholder;

        if (floatingLabel) {
          visibleLabel = hasLabel ? selectedItem.label : '';
        }

        var visualState = {
          isOpen: isOpen,
          isSmall: isSmall,
          hasLabel: hasLabel,
          isInvalid: isInvalid,
          disabled: disabled,
          loading: loading,
          labelHidden: labelHidden,
          floatingLabel: floatingLabel,
          hasSelectedItem: !!selectedItem,
          appearance: appearance,
          nowrap: nowrap,
          alignBody: alignBody,
          dropdownMaxHeight: dropdownMaxHeight,
          hideSelectedOption: hideSelectedOption
        };
        var buttonProps = getToggleButtonProps({
          autoFocus: autoFocus,
          css: styles.selectedItem(visualState),
          disabled: disabled || loading,
          onFocus: onFocus
        });

        var labelElement = ___EmotionJSX("label", _extends({
          // eslint-disable-line jsx-a11y/label-has-for
          css: styles.label(visualState),
          htmlFor: "".concat(id, "-input")
        }, getLabelProps()), label, required && ___EmotionJSX("span", {
          className: "input-wrapper__required",
          css: styles.required,
          role: "presentation",
          "aria-hidden": true
        }, "*"));

        return ___EmotionJSX(SelectRoot, _extends({}, getRootProps({
          refKey: 'innerRef'
        }), {
          css: styles.domainSelect(_objectSpread(_objectSpread({}, visualState), {}, {
            stretched: stretched
          })),
          className: className
        }), !floatingLabel && labelElement, ___EmotionJSX("div", {
          css: styles.selectedItemWrapper(visualState)
        }, ___EmotionJSX("button", _extends({}, buttonProps, {
          css: styles.selectedItem(visualState),
          autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          ,
          onFocus: onFocus,
          disabled: disabled || loading,
          type: "button"
        }), !hideSelectedOption && visibleLabel, appearance === 'borderless' && hideSelectedOption && ___EmotionJSX(MoreCircleIcon, {
          css: styles.moreIcon,
          size: "custom"
        })), ___EmotionJSX("input", _extends({
          css: styles.inputField
        }, getInputProps())), floatingLabel && labelElement, loading && ___EmotionJSX(Loader, {
          css: styles.loader,
          size: "mini",
          transparent: true
        }), appearance === 'borderless' && !hideSelectedOption && ___EmotionJSX(ChevronDownIconSmall, {
          css: styles.chevron(visualState)
        })), isOpen && ___EmotionJSX("div", {
          css: styles.menuOuter(visualState),
          "data-testid": "domain-select-menu-container"
        }, ___EmotionJSX("div", _extends({
          "data-testid": "domain-select-menu",
          css: styles.menu({
            dropdownMaxHeight: dropdownMaxHeight
          })
        }, getMenuProps()), options.map(function (item, index) {
          if (optionComponent) {
            return optionComponent(item, index, highlightedIndex, selectedItem, getItemProps);
          }

          return ___EmotionJSX("div", getItemProps({
            item: item,
            key: item.value,
            css: styles.item(_objectSpread(_objectSpread({}, visualState), {}, {
              isHighlighted: highlightedIndex === index,
              isSelected: highlightedIndex === null && selectedItem === item
            }))
          }), item.label);
        }))));
      });
    }
  }]);

  return Select;
}(React.PureComponent);

Select.propTypes = {
  instanceId: PropTypes.string,
  options: PropTypes.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  isInvalid: PropTypes.bool,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  size: PropTypes.string,
  optionComponent: PropTypes.func,
  label: PropTypes.node.isRequired,
  labelHidden: PropTypes.bool,
  onFocus: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  className: PropTypes.string,
  floatingLabel: PropTypes.bool,
  appearance: PropTypes.oneOf(['regular', 'borderless', 'rounded']),
  alignBody: PropTypes.oneOf(['left', 'right']),
  nowrap: PropTypes.bool,
  dropdownMaxHeight: PropTypes.number,
  stretched: PropTypes.bool,
  required: PropTypes.bool,
  hideSelectedOption: PropTypes.bool
};
Select.defaultProps = {
  instanceId: undefined,
  defaultValue: undefined,
  value: undefined,
  placeholder: '',
  disabled: false,
  loading: false,
  isInvalid: false,
  onChange: noop,
  autoFocus: false,
  size: Size.Regular,
  optionComponent: undefined,
  labelHidden: false,
  onFocus: noop,
  onClose: noop,
  onOpen: noop,
  className: '',
  floatingLabel: false,
  appearance: 'regular',
  alignBody: 'left',
  nowrap: false,
  dropdownMaxHeight: styles.defaultDropdownMaxHeight,
  stretched: false,
  required: false,
  hideSelectedOption: false
};
export default Select;